// HowItWorks.js
import CategoryHeading from '../../Heading/CategoryHeading';
import { ImageWrapper, ResponsiveImage } from './HowItWorks.styled';

const HowItWorks = ({ data }) => {
  return (
    <div
      className='container'
      style={{
        width: '100%',
        textAlign: 'center',
        height: '100%',
        position: 'relative',
      }}
    >
      <CategoryHeading
        headerLeftTitle={data?.headerData?.header}
        headerLeftStyle={true}
      />
      <ImageWrapper>
        <ResponsiveImage images={data} alt='How Its Works Content' />
      </ImageWrapper>
    </div>
  );
};

export default HowItWorks;
